
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import { useScrollLock } from "../../../hooks/useScrollLock"
import styled from "styled-components"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { useEffect } from "react"
import TopPagesMapWideLeftSide from "../../topPagesMap/TopPagesMapWideLeftSide"
import TopPagesMapWideMap from "../../topPagesMap/TopPagesMapWideMap"
import SmallSpinner from "../../shared/spinners/SmallSpinner"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 100%;
        height: 100vh;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        overflow: hidden;

        .content{
            width: 100%;
            height: 100vh;
            display: flex;
        }
    }
`


const TopPagesWideMapModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const { lockScroll, unlockScroll } = useScrollLock();

    const {modalLocation } = useSelector(state => state.modal)

    const {
        topPagesMapSingleShipmentItemLocationList,
        isLoadingGetShipmentDriverLocationsById
    } = useSelector((state) => state.topPagesMap);

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])
    
  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e) => {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <div className="content">
                {
                    (topPagesMapSingleShipmentItemLocationList.length > 0 && !isLoadingGetShipmentDriverLocationsById) ?
                        <>
                            <TopPagesMapWideLeftSide />
                            <TopPagesMapWideMap/>
                        </>
                    : 
                    <SmallSpinner size={"60px"} color={"#fff"} borderSize="6px" bgColor={"#E85446"}/>
                }
            </div>
        </div>
    </ModalContainer>
  )
}

export default TopPagesWideMapModal
